import _ from "underscore";
import { createSource } from "@evertrue/et-flux";
import Api from "utils/api";
import Config from "config/env";

export default createSource("SsoSource", {
  actions: {
    ssoError(method_name, extra) {
      return this.require(_.isString(method_name), "method_name must be a string");
    },
  },

  promise: {
    // Exchange authorization code for tokens via server-side endpoint
    // This keeps Cognito client credentials secure on the server
    fetchAccessToken(sso_code, org_oid, application) {
      return Api.post({
        url: `auth/sso/token`,
        data: {
          authorization_code: sso_code,
          application: application,
          org_slug: org_oid,
        },
        error: (xhr) => {
          if (Config.isDevelopment()) {
            console.log(`https://local-accounts.evertrue.com:3016/evertrue/login/sso?code=${sso_code}`);
          }
          this.actions.ssoError("SsoSource.fetchAccessToken", { xhr });
        },
      });
    },
  },

  api: {
    setDeferredError(name, extra) {
      _.defer(() => {
        this.actions.ssoError(name, extra);
      });
    },
  },
});
